import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { 
  Menu, 
  X, 
  Home, 
  Settings, 
  DollarSign, 
  Palette, 
  Mail, 
  HelpCircle,
  ExternalLink,
  
} from "lucide-react";
import logo from "../assests/logo.png";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const navItems = [
    { path: "/", label: "Accueil", icon: <Home className="w-4 h-4" /> },
    { path: "/services", label: "Services", icon: <Settings className="w-4 h-4" /> },
    { path: "/pricing", label: "Tarifs", icon: <DollarSign className="w-4 h-4" /> },
    { path: "/models", label: "Modèles", icon: <Palette className="w-4 h-4" /> },
    { path: "/contact", label: "Contact", icon: <Mail className="w-4 h-4" /> },
    { path: "/faq", label: "FAQ", icon: <HelpCircle className="w-4 h-4" /> },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-gray-900/90 backdrop-blur-md py-3 shadow-lg border-b border-gray-800' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
          <div className="w-15 h-12 rounded-full overflow-hidden border-2 border-white/10 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
            <img src={logo} alt="Logo Dev-Tech" className="w-full h-full p-2 object-cover" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">
                Dev-<span className="text-blue-400">Tech</span>
              </h1>
              <p className="text-xs text-gray-400">Solutions Digitales</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-gray-300 hover:text-white font-medium transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/devis"
              className="px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-lg hover:opacity-90 transition-opacity"
            >
              Devis Gratuit
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-300" />
            ) : (
              <Menu className="w-6 h-6 text-gray-300" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="md:hidden fixed inset-0 z-40 bg-black/80 backdrop-blur-sm pt-20"
            onClick={() => setIsMenuOpen(false)}
          >
            <motion.div
              initial={{ y: -20 }}
              animate={{ y: 0 }}
              exit={{ y: -20 }}
              className="bg-gray-900 border-t border-gray-800 mx-4 rounded-xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-4 space-y-2">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="flex items-center gap-3 p-3 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
                  >
                    <div className="p-2 rounded-md bg-gray-800">
                      {item.icon}
                    </div>
                    <span className="font-medium">{item.label}</span>
                  </Link>
                ))}
                
                <Link
                  to="/devis"
                  onClick={() => setIsMenuOpen(false)}
                  className="flex items-center justify-center gap-2 mt-4 p-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-lg"
                >
                  <ExternalLink className="w-4 h-4" />
                  Devis Gratuit
                </Link>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}